import React, { useState, useEffect } from "react";
import triggerFinanceWebhook from "../../Services/FinanceService";
import triggerCustomerPanelWebhook from "../../Services/CustomerPanelService";
import triggerUpdateShowroomWebhook from "../../Services/UpdateShowroomService";
import SmWrapper from "../../Components/SmWrapper";
import classes from "../../module.css/NewBooking.module.css";
import Heading from "../../tailwindUI/Heading";
import Input from "../../tailwindUI/Input";
import Button from "../../tailwindUI/Button";
import ErrorMessage from "../../tailwindUI/ErrorMessage";
import SuccessMessage from "../../tailwindUI/SuccessMessage";
import { useNavigate } from "react-router-dom";
import WingsModal from "../../tailwindUI/WingsModal";

const todayDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedToday = yyyy + "-" + mm + "-" + dd;
  return formattedToday;
};

const NewBooking = () => {
  const [wingsData, setWingsData] = useState({});
  const [asmList, setAsmList] = useState([]);

  const [fName, setFname] = useState("");

  const [lName, setLname] = useState("");
  const [mobile, setMobile] = useState("");
  const [bookingDate, setBookingDate] = useState("");
  const [receiptNo, setReceiptNo] = useState("");
  const [selectedModel1, setSelectedModel1] = useState("");
  const [selectedVariant1, setSelectedVariant1] = useState("");
  const [selectedColor1, setSelectedColor1] = useState("");
  const [selectedAsm, setSelectedAsm] = useState("");
  const [selectExecutive, setSelectExecutive] = useState("");
  const [wings, setWings] = useState("");
  const [wingsLoading, setWingsLoading] = useState(false);
  const [bookingAmount, setBookingAmount] = useState("");
  const [financeAmount, setFinanceAmount] = useState("");
  const [dealAmount, setDealAmount] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [committedDate, setCommittedDate] = useState("");

  const [uploadReceipt, setUploadReceipt] = useState("");
  const [yom, setYom] = useState("");

  const [filteredList1, setFilteredList1] = useState([]);
  const [filteredList2, setFilteredList2] = useState([]);

  const [selectedModel2, setSelectedModel2] = useState("");
  const [selectedVariant2, setSelectedVariant2] = useState("");
  const [selectedColor2, setSelectedColor2] = useState("");

  const [executiveList, setExecutiveList] = useState([]);

  // const [selectedStatus, setSelectedStatus] = useState("Allocation Awaited");
  const [exchange, setExchange] = useState("No");
  const [loan, setLoan] = useState("No");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [remark, setRemark] = useState("");
  const [followup1, setFollowup1] = useState("");
  const [followup2, setFollowup2] = useState("");
  const [followup3, setFollowup3] = useState("");
  const [checkedPriority, setCheckedPriority] = useState([]);
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [wingserrorMessage, setWingsErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(true);

  const UserToken = localStorage.getItem("UserToken");
  const checkedPriorityInString = checkedPriority
    .map((item) => item.name)
    .toString();
  const navigate = useNavigate();
  useEffect(
    () => FilterList(selectedModel1, setFilteredList1),
    [selectedModel1]
  );
  useEffect(
    () => FilterList(selectedModel2, setFilteredList2),
    [selectedModel2]
  );

  useEffect(() => {
    asmListApi();
    executiveListApi();
  }, [selectedAsm]);

  useEffect(() => {
    setSelectedVariant1(
      filteredList1?.Variant?.some(
        (vrnt) => vrnt.replace(/\s*\(\d+\)$/, "").trim().toLowerCase() === wingsData?.Variant?.trim().toLowerCase()
      )
        ? filteredList1.Variant.find(
            (vrnt) => vrnt.replace(/\s*\(\d+\)$/, "").trim().toLowerCase() === wingsData?.Variant?.trim().toLowerCase()
          )
        : ""
    );

    setSelectedColor1(
      filteredList1?.Colour?.some(
        (clr) => clr.toLowerCase() === wingsData?.Colour?.toLowerCase()
      )
        ? wingsData?.Colour
        : ""
    );
  }, [filteredList1]);

  useEffect(() => {
    setWingsErrorMessage("");
    setFname(wingsData?.FirstName || "");
    setLname(wingsData?.LastName || "");
    setMobile(wingsData?.CustomerMobile || "");
    setBookingDate(wingsData?.BookingDate || "");
    setReceiptNo(wingsData?.ReceiptNumber || "");
    setSelectedModel1(
      filteredList1?.Model?.some(
        (mdl) => mdl.toLowerCase() === wingsData?.Model?.toLowerCase()
      )
        ? filteredList1?.Model?.find(
          (mdl) => mdl.toLowerCase() === wingsData?.Model?.toLowerCase()
        )
        : ""
    );
    // setSelectedVariant1(
    //   filteredList1?.Variant?.some(
    //     (vrnt) => vrnt.toLowerCase() === wingsData?.Variant?.toLowerCase()
    //   )
    //     ? wingsData?.Variant
    //     : ""
    // );
    // setSelectedColor1(
    //   filteredList1?.Colour?.some(
    //     (clr) => clr.toLowerCase() === wingsData?.Colour?.toLowerCase()
    //   )
    //     ? wingsData?.Colour
    //     : ""
    // );
    setSelectedAsm(
      asmList.filter((asmId) => asmId.AsmID === wingsData.ASMId)
        ? wingsData?.ASMId
        : ""
    );
    setWings(wingsData?.WingsId || "");
    setBookingAmount(wingsData?.BookingAmount || "");
    setSelectExecutive(
      executiveList.some(
        (executiveName) => executiveName.ExecutiveId === wingsData.ExecutiveId
      )
        ? wingsData?.ExecutiveId
        : ""
    );
  }, [wingsData]);

  const bookingPriorityList = [
    {
      name: "Full Payment",
    },

    {
      name: "Special Occasion",
    },

    {
      name: "Committed Date",
    },
    {
      name: "Owner Reference",
    },
    {
      name: "Other Reference",
    },
  ];

  const priorityCheckboxHandler = (option) => {
    const isChecked = checkedPriority.some((item) => item.name === option.name);
    if (isChecked) {
      setCheckedPriority(
        checkedPriority.filter((item) => item.name !== option.name)
      );
    } else {
      setCheckedPriority(checkedPriority.concat(option));
    }
  };
  const notificationMethods = [
    { id: "Yes", title: "Yes" },
    { id: "No", title: "No" },
  ];
  const paymentOptions = [
    { id: "Cash", title: "Cash" },
    { id: "Self Finance", title: "Self Finance" },
    { id: "In House Finance", title: "In House Finance" },
  ];
  const loanOptions = [
    { id: "Yes1", title: "Yes" },
    { id: "No1", title: "No" },
  ];

  const onlyNumeric = (e, setState) => {
    var reg = /^-?\d+$/;
    reg.test(e.target.value) || e.target.value === ""
      ? setState(e.target.value)
      : console.log("");
  };

  const validYear = (date) => {
    return date.split("-")[0];
  };

  const validation = () => {
    var commitedDate = new Date(committedDate);
    var bookingdate = new Date(bookingDate);
    let regPhone = /^[6789][0-9]{9}$/;
    let yomregex = /^[0-9\b]+$/;
    let receiptregex =
      /^[a-zA-Z0-9]+\/[a-zA-Z0-9]+\/[a-zA-Z0-9]+\/[a-zA-Z0-9]+$/;
    let receiptnewregex = /^[a-zA-Z]{1}\d{10}$/;
    let isValid = true;
    let error = {};
    if (fName.trim() === "") {
      isValid = false;
      error.fName = "Please enter first name";
    }
    if (lName.trim() === "") {
      isValid = false;
      error.lName = "Please enter last name";
    }
    if (!regPhone.test(mobile)) {
      isValid = false;
      error.mobile = "Invalid mobile number";
    }
    if (mobile.trim() === "") {
      isValid = false;
      error.mobile = "Please enter mobile number";
    }
    if (bookingAmount.toString()?.trim() === "") {
      isValid = false;
      error.bookingAmount = "Please enter booking amount";
    }
    if (bookingDate === "") {
      isValid = false;
      error.bookingDate = "Please select booking date";
    }

    if (
      parseInt(validYear(bookingDate)) < 2016 ||
      parseInt(validYear(bookingDate)) > 2099
    ) {
      isValid = false;
      error.bookingDate = "Enter valid date";
    }

    if (committedDate === "") {
      isValid = false;
      error.committedDate = "Please select committed date";
    }

    if (
      parseInt(validYear(committedDate)) < 2016 ||
      parseInt(validYear(committedDate)) > 2099
    ) {
      isValid = false;
      error.committedDate = "Enter valid date";
    }
    if (commitedDate < bookingdate) {
      error.committedDate = "Please enter valid date";
      isValid = false;
    }
    if (paymentMethod === "") {
      isValid = false;
      error.paymentMethod = "Please enter Payment Method";
    }
    if (loan === "") {
      isValid = false;
      error.loan = "Please enter Loan Approved";
    }

    if (dealAmount === "") {
      isValid = false;
      error.dealAmount = "Please enter Final Deal Amount";
    }

    if (yom === "") {
      isValid = false;
      error.yom = "Please enter YOM";
    } else if (!yomregex.test(yom)) {
      isValid = false;
      error.yom = "Please enter correct year of manufacturing";
    } else if (yom > new Date().getFullYear() + 1) {
      isValid = false;
      error.yom = "Year of manufacture should be valid";
    }

    if (receiptNo.trim() === "") {
      isValid = false;
      error.receiptNo = "Please enter receipt number";
    }
    // } else if (
    //   // !receiptnewregex.test(receiptNo) &&
    //   !receiptregex.test(receiptNo)
    // ) {
    //   isValid = false;
    //   error.receiptNo = "Please enter receipt number in correct format";
    // }

    // if (uploadReceipt === "") {
    //   isValid = false;
    //   error.uploadReceipt = "Please upload receipt";
    // }

    if (selectedModel1 === "") {
      isValid = false;
      error.selectedModel1 = "Please select car model";
    }

    if (selectedVariant1 === "") {
      isValid = false;
      error.selectedVariant1 = "Please select car variant";
      // window.scrollTo(0, 600);
    }

    if (selectedColor1 === "") {
      isValid = false;
      error.selectedColor1 = "Please select car color";
      // window.scrollTo(0, 600);
    }

    if (selectedModel2 === "") {
      isValid = false;
      error.selectedModel2 = "Please select car model";
    }

    if (selectedVariant2 === "") {
      isValid = false;
      error.selectedVariant2 = "Please select car variant";
      // window.scrollTo(0, 600);
    }

    if (selectedColor2 === "") {
      isValid = false;
      error.selectedColor2 = "Please select car color";
      // window.scrollTo(0, 600);
    }

    if (
      selectedModel1 === selectedModel2 &&
      selectedVariant1 === selectedVariant2 &&
      selectedColor1 === selectedColor2 &&
      selectedModel1 !== "" &&
      selectedColor2 !== "" &&
      selectedVariant2 !== ""
    ) {
      isValid = false;
      error.prefrence2 = "Prefrence1 and Prefrence2 can not be same";
    }

    // if (wings === "") {
    //   isValid = false;
    //   error.wings = "Please enter wings id";

    // }
    if (selectedAsm === "") {
      isValid = false;
      error.selectedAsm = "Please select ASM";
      // window.scrollTo(0, 900);
    }
    if (selectExecutive === "") {
      isValid = false;
      error.selectExecutive = "Please select executive";
      // window.scrollTo(0, 900);
    }
    // if (selectedStatus === "") {
    //   isValid = false;
    //   error.selectedStatus = "Please select status";
    //   // window.scrollTo(0, 900);
    // }
    // if (statusDate === "") {
    //   isValid = false;
    //   error.statusDate = "Please select status date";
    //   // window.scrollTo(0, 900);
    // }

    if (exchange === "") {
      isValid = false;
      error.exchange = "Please select exchange";
    }
    if (loan === "") {
      isValid = false;
      error.loan = "Please select loan approved";
    }
    console.log(error, "error");
    setErrors(error);
    return isValid;
  };
  const LogOut = () => {
    localStorage.removeItem("UserName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
    localStorage.removeItem("UserToken");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("Location");
    localStorage.removeItem("Email");
    localStorage.removeItem("UserLoggedin");
    navigate("/login", { replace: true });
  };
  const FilterList = (model, setFilteredList) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      Model: model,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/common/GetFilterList`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success" && result.status_code === 200) {
          setFilteredList(result.data);
        } else if (result.status_code === 400) {
          setErrorMessage("Something went wrong please contact support !");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      });
  };

  const asmListApi = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/srm/SRMASMList`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login" ||
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (
          result.status === "Success" &&
          result.status_code === 200 &&
          result.message === "Data Found Successfully"
        ) {
          setAsmList(result.data);
        } else if (result.status_code === 400) {
          setErrorMessage("Something went wrong please contact support !");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      });
  };

  console.log("first", selectedColor1);

  const executiveListApi = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
      AsmId: selectedAsm,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/srm/SRMExicutivesList`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login" ||
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (
          result.status === "Success" &&
          result.status_code === 200 &&
          result.message === "Data Found Successfully"
        ) {
          setExecutiveList(result.data);
          if (wingsData?.ExecutiveId) {
            setSelectExecutive(
              result.data.some(
                (item) => item.ExecutiveId === wingsData.ExecutiveId
              )
                ? wingsData?.ExecutiveId
                : ""
            );
          }
        } else if (result.status_code === 400) {
          setErrorMessage("Something went wrong please contact support !");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      });
  };

  const formSubmitHandler = () => {
    if (validation()) {
      setLoading(true);
      var myHeaders = new Headers();
      myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);

      var formdata = new FormData();
      formdata.append("UserToken", UserToken);
      formdata.append("FirstName", fName);
      formdata.append("LastName", lName);
      formdata.append("MobileNumber", mobile);
      formdata.append("Model1", selectedModel1);
      formdata.append("Model2", selectedModel2);
      formdata.append("Variant1", selectedVariant1);
      formdata.append("Variant2", selectedVariant2);
      formdata.append("Colour1", selectedColor1);
      formdata.append("Colour2", selectedColor2);
      formdata.append("BookingAmount", bookingAmount);
      formdata.append("YOM", yom);
      formdata.append("DateOfBooking", bookingDate);
      formdata.append("CommittedDeliveryDate", committedDate);
      formdata.append("BookingPriority", checkedPriorityInString);
      formdata.append("BookingPriorityResoan", "");
      // formdata.append("Status", selectedStatus);
      formdata.append("UploadReceipt", uploadReceipt);
      formdata.append("ReceiptNo", receiptNo);
      formdata.append("WingsId", wings);
      formdata.append("Exchange", exchange);
      formdata.append("ASM", selectedAsm);
      formdata.append("Executive", selectExecutive);
      // formdata.append("StatusDate", statusDate);
      formdata.append("FinalDealAmount", dealAmount);
      formdata.append("PaymentMethod", paymentMethod);
      formdata.append("FinanceAmount", financeAmount);
      formdata.append("LoanApproved", loan);
      formdata.append("Remark", remark);
      formdata.append("Followup1", followup1);
      formdata.append("Followup2", followup2);
      formdata.append("Followup3", followup3);
      // formdata.append("WingsId", "123456");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/srm/SRMBookingAdd`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status_code === 200 && result.status === "Success") {
            // Trigger Finance Webhook directly with the returned BookingID
            if (result.data && result.data.BookingID) {
              triggerFinanceWebhook(result.data.BookingID);
            }

            // Trigger Customer Panel Webhook with Wings ID
            if (result.data && result.data.WingsId) {
              triggerUpdateShowroomWebhook(result.data.WingsId)
                .then((success) => {
                  if (success) {
                    triggerCustomerPanelWebhook(result.data.WingsId);
                  } else {
                    console.warn("Update Showroom webhook did not return success, skipping Customer Panel webhook.");
                  }
                })
                .catch((err) => console.error("Update Showroom webhook error:", err));
            }

            setMessage("Booking Added Successfully");
            setFname("");
            setLname("");
            setMobile("");
            setWings("");
            setBookingDate("");
            setCommittedDate("");
            setCheckedPriority([]);
            setSelectedModel1("");
            setSelectedVariant1("");
            setSelectedColor1("");
            setSelectedModel2("");
            setSelectedVariant2("");
            setSelectedColor2("");
            setBookingAmount("");
            setYom("");
            // setSelectedStatus("");
            setUploadReceipt(null);
            setReceiptNo("");
            setExchange("");
            setPaymentMethod("");
            setFinanceAmount("");
            setLoan("");
            setDealAmount("");
            setSelectedAsm("");
            setSelectExecutive("");
            // setStatusDate("");
            // setVinNumber("");
            setRemark("");
            setFollowup1("");
            setFollowup2("");
            setFollowup3("");
          } else if (result.status_code === 400) {
            setErrorMessage("Something went wrong please contact support !");
          }
        })
        .catch((error) => {
          console.log("error", error);
          setErrorMessage("Something went wrong please contact support !");
        })
        .finally(() => setLoading(false));
    }
  };

  const successMessage = () => {
    setTimeout(() => {
      setMessage("");
      navigate("/sm-search-update");
    }, 2000);
    return message;
  };
  const BreadCrumb = {
    pagename: "New booking",
    pagePath: "/sm-new-booking",
  };

  const fetchWingsData = (wingsId) => {
    setWingsErrorMessage("");
    setWingsLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
      ReceiptNumber: wingsId,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/srm/GetWingsBookingDetail`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login" ||
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (result.status === "Success" && result.status_code === 200) {
          if (result.message === "Data Found Successfully") {
            setWingsLoading(false);
            setShowModal(false);
            setWingsData(result.data);
          } else if (result.message === "Booking Already Exists") {
            setWingsErrorMessage("Booking Already Exists!!");
          } else if (result.message === "Data not found for Asm") {
            setWingsErrorMessage("Not Authorised to see this data");
          } else if (result.message === "Data not found") {
            setWingsErrorMessage("Receipt No. does not exist.");
          } else if (result.message === "Booking WingsId Not Valid") {
            setWingsErrorMessage("Booking Details Incomplete");
          } else if (result.message === "Booking WingsId Not Valid") {
            setWingsErrorMessage("Booking Details Incomplete");
          } else if (result.message === "Data not found for Showroommanager") {
            setWingsErrorMessage("Not Authorised to see this data");
          } else if (
            result.message &&
            result.message.includes("contact the cashier")
          ) {
            setWingsErrorMessage(result.message);
            console.log("Error Message Set:", result.message);
          }
        }
      })
      .catch((error) => {
        console.log("error", error);
        setWingsErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => setWingsLoading(false));
  };

  return (
    <SmWrapper>
      {showModal && (
        <WingsModal
          fetchWingsData={fetchWingsData}
          wingsLoading={wingsLoading}
          wingserrorMessage={wingserrorMessage}
        />
      )}
      {message && <SuccessMessage message={successMessage()} />}
      {errorMessage && <ErrorMessage message={errorMessage} />}
      <Heading
        headingType={"Page Headings small"}
        BreadCrumHomeLink={"/sm-dashboard"}
        headingText={"New Booking"}
        BreadCrumb={BreadCrumb}
        subheadingText={localStorage.getItem("Location")}
      />

      <div className={classes.mainContainer}>
        <div className={classes.searchContainer}>
          <div className={classes.headingFormContainer}>
            <Heading
              headingType={"sub heading small"}
              headingText={"Customer Details"}
            />

            <div className={classes.inputRow}>
              <div className={wingsData.FirstName && classes.inputDisable}>
                <Input
                  disabled={wingsData.FirstName}
                  type={"input with label low height"}
                  inputType={"text"}
                  label={"First Name *"}
                  onChange={(e) => {
                    setFname(e.target.value);
                    errors.fName = "";
                  }}
                  value={fName}
                  error={errors.fName}
                />
                <span className={classes.error}>{errors.fName}</span>
              </div>
              <div className={wingsData.LastName && classes.inputDisable}>
                <Input
                  type={"input with label low height"}
                  disabled={wingsData?.LastName}
                  inputType={"text"}
                  label={"Last Name *"}
                  onChange={(e) => {
                    setLname(e.target.value);
                    errors.lName = "";
                  }}
                  value={lName}
                  error={errors.lName}
                />
                <span className={classes.error}>{errors.lName}</span>
              </div>
              <div className={wingsData.CustomerMobile && classes.inputDisable}>
                <Input
                  type={"input with label low height"}
                  disabled={wingsData?.CustomerMobile}
                  inputType={"text"}
                  maxLength={13}
                  label={"Mobile Number *"}
                  onChange={(e) => {
                    onlyNumeric(e, setMobile);
                    errors.mobile = "";
                  }}
                  value={mobile}
                  error={errors.mobile}
                />
                <span className={classes.error}>{errors.mobile}</span>
              </div>

              <div className={wingsData.BookingAmount && classes.inputDisable}>
                <Input
                  type={"input with label low height"}
                  inputType={"text"}
                  disabled={wingsData?.BookingAmount}
                  label={"Booking Amount *"}
                  value={bookingAmount}
                  onChange={(e) => {
                    onlyNumeric(e, setBookingAmount);
                    errors.bookingAmount = "";
                  }}
                  error={errors.bookingAmount}
                />
                <span className={classes.error}>{errors.bookingAmount}</span>
              </div>

              <div
                className={
                  asmList.some((asmId) => asmId.AsmID === wingsData.ASMId) &&
                  classes.inputDisable
                }
              >
                <Input
                  type={"Select Menus Simple native low height"}
                  label={"ASM *"}
                  disabled={asmList.some(
                    (asmId) => asmId.AsmID === wingsData.ASMId
                  )}
                  dropdownType={"asmBookingNew"}
                  asmData={asmList}
                  wingsAsmId={wingsData.ASMId}
                  selected={selectedAsm === ""}
                  onChange={(e) => {
                    setSelectedAsm(e.target.value);
                    errors.selectedAsm = "";
                  }}
                  error={errors.selectedAsm}
                />
                <span className={classes.error}>{errors.selectedAsm}</span>
              </div>
              <div
                className={
                  executiveList.some(
                    (executiveName) =>
                      executiveName.ExecutiveId === wingsData.ExecutiveId
                  ) && classes.inputDisable
                }
              >
                <Input
                  type={"Select Menus Simple native low height"}
                  disabled={executiveList.some(
                    (executiveName) =>
                      executiveName.ExecutiveId === wingsData.ExecutiveId
                  )}
                  label={"Executive *"}
                  dropdownType={"newExecutive"}
                  executiveData={executiveList}
                  value={selectExecutive}
                  onChange={(e) => {
                    setSelectExecutive(e.target.value);
                    errors.selectExecutive = "";
                  }}
                  error={errors.selectExecutive}
                />
                <span className={classes.error}>{errors.selectExecutive}</span>
              </div>
            </div>
            <div className={classes.inputRow}>
              <div className={wingsData.BookingDate && classes.inputDisable}>
                <Input
                  type={"input with label low height"}
                  disabled={wingsData?.BookingDate}
                  inputType={"date"}
                  label={"Date of Booking *"}
                  onChange={(e) => {
                    setBookingDate(e.target.value);
                    errors.bookingDate = "";
                  }}
                  value={bookingDate}
                  error={errors.bookingDate}
                  onKeyDown={(e) => e.preventDefault()}
                />
                <span className={classes.error}>{errors.bookingDate}</span>
              </div>

              <div>
                <Input
                  type={"input with label low height"}
                  inputType={"date"}
                  label={"Commited Delivery Date*"}
                  onChange={(e) => {
                    setCommittedDate(e.target.value);
                    errors.committedDate = "";
                  }}
                  value={committedDate}
                  error={errors.committedDate}
                  onKeyDown={(e) => e.preventDefault()}
                />
                <span className={classes.error}>{errors.committedDate}</span>
              </div>
              <div className={wingsData.WingsId && classes.inputDisable}>
                <Input
                  type={"input with label low height"}
                  inputType={"text"}
                  disabled={wingsData?.WingsId}
                  label={"WINGS ID"}
                  onChange={(e) => {
                    setWings(e.target.value);
                    errors.wings = "";
                  }}
                  value={wings}
                  error={errors.wings}
                />
                <span className={classes.error}>{errors.wings}</span>
              </div>
              <div>
                <div className="block text-sm font-medium text-gray-700">
                  Booking Priority
                </div>
                <Input
                  type={"Select Menus with checkbox"}
                  label={"Booking Priority"}
                  data={bookingPriorityList}
                  selected={checkedPriority}
                  priorityCheckboxHandler={priorityCheckboxHandler}
                  checkedPriority={checkedPriority}
                  error={errors.checkedPriority}
                  allError={errors}
                />
                {/* <span className={classes.error}>{errors.checkedPriority}</span> */}
              </div>
              <div className={wingsData.ReceiptNumber && classes.inputDisable}>
                <Input
                  type={"input with label low height"}
                  inputType={"text"}
                  disabled={wingsData?.ReceiptNumber}
                  label={"Receipt No *"}
                  value={receiptNo}
                  placeholder=""
                  onChange={(e) => {
                    setReceiptNo(e.target.value);
                    errors.receiptNo = "";
                  }}
                  error={errors.receiptNo}
                />
                <span className={classes.error}>{errors.receiptNo}</span>
              </div>
              {/* <div>
                <Input
                  type={"input with label low height type file"}
                  inputType={"file"}
                  accept={"image/png, image/gif, image/jpeg"}
                  label={"Upload Receipt"}
                  onChange={(e) => {
                    setUploadReceipt(e.target.files[0]);
                    errors.uploadReceipt = "";
                  }}
                  error={errors.uploadReceipt}
                />
                <span className={classes.error}>{errors.uploadReceipt}</span>
              </div> */}
            </div>
          </div>
          <div className={classes.headingFormContainer}>
            <Heading
              headingType={"sub heading small"}
              headingText={"Vehicle preference"}
            />
            <div>
              <div className={classes.preferenceWrapper}>
                <div>
                  <div className={classes.preference}>Preference 1</div>
                  <div className={classes.preferenceRow}>
                    <div>
                      <Input
                        type={"Select Menus Simple native low height"}
                        // disabled={filteredList1?.Model?.some(
                        //   (item) =>
                        //     item?.toLowerCase() ===
                        //     wingsData?.Model.toLowerCase()
                        // )}
                        wingsModal={wingsData?.Model}
                        label={"Model *"}
                        dropdownType={"WingsModel"}
                        filteredData={filteredList1}
                        selected={selectedModel1 === ""}
                        model={selectedModel1}
                        onChange={(e) => {
                          setSelectedModel1(e.target.value);
                          errors.selectedModel1 = "";
                        }}
                        error={errors.selectedModel1}
                        disabled={Boolean(receiptNo && receiptNo.trim())}
                      />
                      <span className={classes.error}>
                        {errors.selectedModel1}
                      </span>
                    </div>
                    <div>
                      <Input
                        type={"Select Menus Simple native low height"}
                        label={"Variant *"}
                        dropdownType={"Variant"}
                        value={selectedVariant1}
                        wingsVariant={wingsData?.Variant}
                        selected={selectedVariant1 === ""}
                        filteredData={filteredList1}
                        onChange={(e) => {
                          setSelectedVariant1(e.target.value);
                          errors.selectedVariant1 = "";
                        }}
                        error={errors.selectedVariant1}
                        disabled={Boolean(receiptNo && receiptNo.trim())}
                      />
                      <span className={classes.error}>
                        {errors.selectedVariant1}
                      </span>
                    </div>
                    <div>
                      <Input
                        type={"Select Menus Simple native low height"}
                        label={"Color *"}
                        dropdownType={"Color"}
                        value={selectedColor1}
                        wingsColor={wingsData.Colour}
                        filteredData={filteredList1}
                        selected={selectedColor1 === ""}
                        onChange={(e) => {
                          setSelectedColor1(e.target.value);
                          errors.selectedColor1 = "";
                        }}
                        error={errors.selectedColor1}
                        disabled={false}
                      />
                      <span className={classes.error}>
                        {errors.selectedColor1}
                      </span>
                    </div>
                  </div>
                </div>

                <div>
                  <div className={classes.preference}>Preference 2</div>

                  <div className={`${classes.preferenceRow} `}>
                    <div>
                      <Input
                        type={"Select Menus Simple native low height"}
                        label={"Model *"}
                        dropdownType={"Model"}
                        filteredData={filteredList2}
                        selected={selectedModel2 === ""}
                        onChange={(e) => {
                          setSelectedModel2(e.target.value);
                          errors.selectedModel2 = "";
                          errors.prefrence2 = "";
                        }}
                        error={errors.selectedModel2}
                      />
                      <span className={classes.error}>
                        {errors.selectedModel2}
                      </span>
                    </div>

                    <div>
                      <Input
                        type={"Select Menus Simple native low height"}
                        label={"Variant *"}
                        dropdownType={"Variant"}
                        selected={selectedVariant2 === ""}
                        value={selectedVariant2}
                        filteredData={filteredList2}
                        onChange={(e) => {
                          setSelectedVariant2(e.target.value);
                          errors.selectedVariant2 = "";
                          errors.prefrence2 = "";
                        }}
                        error={errors.selectedVariant2}
                      />
                      <span className={classes.error}>
                        {errors.selectedVariant2}
                      </span>
                    </div>
                    <div>
                      <Input
                        type={"Select Menus Simple native low height"}
                        label={"Color *"}
                        dropdownType={"Color"}
                        filteredData={filteredList2}
                        value={selectedColor2}
                        selected={selectedColor2 === ""}
                        onChange={(e) => {
                          setSelectedColor2(e.target.value);
                          errors.selectedColor2 = "";
                          errors.prefrence2 = "";
                        }}
                        error={errors.selectedColor2}
                      />
                      <span className={classes.error}>
                        {errors.selectedColor2}
                      </span>
                    </div>
                  </div>
                  <span className={classes.error}>{errors.prefrence2}</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <Heading
              headingType={"sub heading small"}
              headingText={"Other Details"}
            />
            <div className={classes.inputRow}>
              <div>
                <label
                  className=" text-sm font-medium text-gray-700"
                  htmlFor="yomDropdown"
                >
                  YOM *
                </label>
                <br />
                <select
                  className={`mt-1 block w-full border  outline-none text-sm rounded-md border-gray-300 px-2 py-1   ${errors.yom
                    ? "border-red-500 focus:ring-orange-500 bg-white"
                    : "focus:border-indigo-500 focus:ring-indigo-500 bg-white"
                    }`}
                  id="yomDropdown"
                  value={yom}
                  onChange={(e) => {
                    setYom(e.target.value);
                    errors.yom = "";
                  }}
                >
                  <option value="" disabled>
                    Select Year
                  </option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                </select>
                <br /> {/* New line after the dropdown */}
                <span className={classes.error}>{errors.yom}</span>
              </div>
              <div className={classes.radiobuttonWrapper}>
                <div>
                  <Input
                    type={"radio group"}
                    label="Exchange *"
                    value={exchange}
                    setState={setExchange}
                    data={notificationMethods}
                    onChange={() => (errors.exchange = "")}
                  />

                  <span className={classes.error}>{errors.exchange}</span>
                </div>
              </div>
              <div className={` mt-1`}>
                <Input
                  type={"input with label low height"}
                  inputType={"text"}
                  label={"Final Deal Amount *"}
                  value={dealAmount}
                  onChange={(e) => {
                    onlyNumeric(e, setDealAmount);
                    errors.dealAmount = "";
                  }}
                  error={errors.dealAmount}
                />
                <span className={classes.error}>{errors.dealAmount}</span>
              </div>
              {/* <div className={`mt-1`}>
                <Input
                  type={"input with label low height"}
                  inputType={"text"}
                  label={"Finance Amount*"}
                  value={financeAmount}
                  onChange={(e) => {
                    onlyNumeric(e, setFinanceAmount);
                    errors.financeAmount = "";
                  }}
                  error={errors.financeAmount}
                />
                <span className={classes.error}>{errors.financeAmount}</span>
              </div> */}

              {/* <div className={classes.radiobuttonWrapper}>
                <div>
                  <Input
                    type={"radio group"}
                    label="Payment Method *"
                    value={paymentMethod}
                    setState={setPaymentMethod}
                    data={paymentOptions}
                    onChange={() => (errors.exchange = "")}
                  />

                  <span className={classes.error}>{errors.exchange}</span>
                </div>
              </div> */}
              <div>
                <label
                  className=" text-sm font-medium text-gray-700"
                  htmlFor="paymentdropdown"
                >
                  Payment Method *
                </label>
                <br />
                <select
                  className={`mt-1 block w-full border  outline-none text-sm rounded-md border-gray-300 px-2 py-1   ${errors.paymentMethod
                    ? "border-red-500 focus:ring-orange-500 bg-white"
                    : "focus:border-indigo-500 focus:ring-indigo-500 bg-white"
                    }`}
                  id="paymentdropdown"
                  value={paymentMethod}
                  onChange={(e) => {
                    setPaymentMethod(e.target.value);
                    errors.paymentMethod = "";
                  }}
                >
                  <option value="" disabled>
                    Select Payment Method
                  </option>
                  <option value="Cash ">Cash </option>
                  <option value="Self Finance">Self Finance</option>
                  <option value="In House Finance">In House Finance</option>
                </select>

                <span className={classes.error}>{errors.paymentMethod}</span>
              </div>
              <div className={classes.radiobuttonWrapper}>
                <div>
                  <Input
                    type={"radio group loan"}
                    label="Loan Approved *"
                    value={loan}
                    setState={setLoan}
                    data={loanOptions}
                    onChange={() => (errors.loan = "")}
                  />

                  <span className={classes.error}>{errors.loan}</span>
                </div>
              </div>

              {/* <div className={`${classes.inputWrapper} col-span-4`}>
                <div>
                  <Input
                    type={"textarea"}
                    inputType={"text"}
                    rows={1}
                    label={"Remark "}
                    onChange={(e) => {
                      setRemark(e.target.value);
                    }}
                    value={remark}
                  />
                </div>
              </div> */}
              {/* <div>
                <Input
                  type={"Select Menus Simple native low height"}
                  label={"Status *"}
                  dropdownType={"status"}
                  status={selectedStatus}
                  error={errors.selectedStatus}
                />
                <span className={classes.error}>{errors.selectedStatus}</span>
              </div> */}
              {/* <div>
                <Input
                  type={"input with label low height"}
                  inputType={"date"}
                  label={"Status Date *"}
                  disabled={true}
                  // onChange={(e) => {
                  //   console.log(e.target.value);
                  //   errors.statusDate = "";
                  // }}
                  value={statusDate}
                  error={errors.statusDate}
                />
                <span className={classes.error}>{errors.statusDate}</span>
              </div> */}

              {/* <div>
                <Input
                  type={"input with label low height"}
                  inputType={"text"}
                  label={"VIN No "}
                  disabled={true}
                  onChange={(e) => {
                    setVinNumber(e.target.value);
                  }}
                  value={vinNumber}
                />
              </div> */}
            </div>

            <div className={classes.rigthSide}>
              <div className={`${classes.inputWrapper} col-span-1`}>
                <div>
                  <Input
                    type={"textarea"}
                    inputType={"text"}
                    rows={1}
                    label={"Remark "}
                    onChange={(e) => {
                      setRemark(e.target.value);
                    }}
                    value={remark}
                  />
                </div>
              </div>
              <div className={classes.inputWrapper}>
                <Input
                  type={"textarea"}
                  inputType={"text"}
                  rows={1}
                  label={"Follow Up 1"}
                  onChange={(e) => setFollowup1(e.target.value)}
                  value={followup1}
                />
              </div>
              <div className={classes.inputWrapper}>
                <Input
                  type={"textarea"}
                  inputType={"text"}
                  rows={1}
                  label={"Follow Up 2"}
                  onChange={(e) => setFollowup2(e.target.value)}
                  value={followup2}
                />
              </div>
              <div className={classes.inputWrapper}>
                <Input
                  type={"textarea"}
                  inputType={"text"}
                  rows={1}
                  label={"Follow Up 3"}
                  onChange={(e) => setFollowup3(e.target.value)}
                  value={followup3}
                />
              </div>
            </div>
            <div className={classes.submitButtonWrapper}>
              <Button
                type={"whiteButton"}
                buttonText={"Cancel"}
                onClick={() => navigate("/sm-dashboard")}
              />
              <div className={classes.submitButton}>
                <Button
                  type={"smallButton"}
                  buttonText={"Save"}
                  onClick={() => {
                    formSubmitHandler();
                  }}
                  loading={loading}
                  disabled={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </SmWrapper>
  );
};

export default NewBooking;
